import { FC } from 'react';
import { IonBreadcrumbs } from '@ionic/react';
import { AllieBreadcrumbsProps } from './Breadcrumbs.types';
import { StyledBreadcrumb } from './Breadcrumb.style';

export const AllieBreadcrumbs: FC<AllieBreadcrumbsProps> = ({
  items,
  ...props
}) => (
  <IonBreadcrumbs {...props}>
    {items &&
      items.map((el) => {
        const { name, selected, ...rest } = el;
        return (
          <StyledBreadcrumb
            className='allie-text-body2'
            selected={selected}
            {...rest}
          >
            {el.name}
          </StyledBreadcrumb>
        );
      })}
  </IonBreadcrumbs>
);
